import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Container, Row, NumberInput } from 'components'
import { InteractionMobileMoneyPaymentIcon } from 'assets'
import { colors } from 'styles/colors'
import { TFunction } from 'react-i18next'
import { constants } from 'helpers'

type MobileMoneyAmountType = {
    continueHandler: (amount: number) => void
    continueButtonText?: string
    t: TFunction<'translation', string>
    initialValue?: number
}

export const MobileMoneyAmount = ({
    continueHandler,
    continueButtonText,
    t,
    initialValue = 0
}: MobileMoneyAmountType) => {
    const [mobileMoneyAmount, setMobileMoneyAmount] = useState<number | null>(
        initialValue
    )

    const showContinueButton = useMemo(() => {
        return (
            mobileMoneyAmount !== null &&
            mobileMoneyAmount >= constants.MIN_MOBILE_MONEY_AMOUNT &&
            mobileMoneyAmount % constants.MOBILE_MONEY_AMOUNT_STEP === 0
        )
    }, [mobileMoneyAmount])

    const [showAmountError, setShowAmountError] = useState(false)

    useEffect(() => {
        if (
            mobileMoneyAmount === null ||
            mobileMoneyAmount === 0 ||
            showContinueButton
        ) {
            setShowAmountError(false)
            return
        }

        setShowAmountError(false)
        const timeoutId = window.setTimeout(() => {
            setShowAmountError(true)
        }, constants.MOBILE_MONEY_AMOUNT_ERROR_DELAY_MS)

        return () => window.clearTimeout(timeoutId)
    }, [mobileMoneyAmount, showContinueButton])

    return (
        <Container sm={12} className="mobile-money--container">
            <Row>
                <Col md={12} className="mobile-money--title-container">
                    <InteractionMobileMoneyPaymentIcon color={colors.black} />
                    <p className="mobile-money--title">
                        {t('enrollment.mobileMoney')}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mobile-money--input-container">
                    <div
                        className={`mobile-money--amount${
                            showAmountError
                                ? ' mobile-money--amount--error'
                                : ''
                        }`}
                    >
                        <div className="mobile-money--amount-field">
                            <NumberInput
                                length={5}
                                onChangeNumberHandler={(amount) =>
                                    setMobileMoneyAmount(
                                        amount === '' ? null : Number(amount)
                                    )
                                }
                                className="enrollment--input-number mobile-money--input-field"
                                placeholder={t('enterAmount')}
                                initialValue={
                                    mobileMoneyAmount
                                        ? mobileMoneyAmount.toString()
                                        : ''
                                }
                            />
                            <p className="mobile-money--input-label">CFA</p>
                        </div>
                        {showAmountError && (
                            <p
                                className="mobile-money--amount-error"
                                data-testid="mobile-money-amount-error"
                            >
                                {t('mobileMoney.amountStep', {
                                    step: constants.MOBILE_MONEY_AMOUNT_STEP
                                })}
                            </p>
                        )}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mobile-money--button-container">
                    {showContinueButton && (
                        <div className="client-details--bottom-button-parent">
                            <Button
                                className="client-details--bottom-button"
                                style="primary"
                                onClick={() => {
                                    if (mobileMoneyAmount) {
                                        continueHandler(mobileMoneyAmount)
                                    }
                                }}
                            >
                                {continueButtonText || t('continue')}
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
